import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

import { PlanningMode } from "@/common/components/appointments/plan-attendance/PlanAttendanceDialog.types";
import { useTranslation } from "@/translations";

interface Props {
  value: PlanningMode;
  onChange: (mode: PlanningMode) => void;
}

const LABEL_ID = "planning-mode-label";

export function PlanningModeSelect({ value, onChange }: Props) {
  const { t } = useTranslation();

  return (
    <FormControl size="small" sx={{ minWidth: 350 }}>
      <InputLabel id={LABEL_ID}>{t("calendar.planAttendance.planningMode")}</InputLabel>
      <Select
        labelId={LABEL_ID}
        label={t("calendar.planAttendance.planningMode")}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <MenuItem value={PlanningMode.Weekly}>{t("calendar.planAttendance.planningModeWeekly")}</MenuItem>
        <MenuItem value={PlanningMode.WeeklySeries}>{t("calendar.planAttendance.planningModeWeeklySeries")}</MenuItem>
        <MenuItem value={PlanningMode.MultiDay}>{t("calendar.planAttendance.planningModeMultiDay")}</MenuItem>
      </Select>
    </FormControl>
  );
}
